<script>
import { api } from "@/state/services";

export default {
  props: {
    id: {
      default: ""
    },
    quantity: {
      default: ""
    },
    edit: {
      default: "yes"
    }
  },
  components: { },
  data() {
    return {
      loading: false,
      qty: this.$props.quantity,
    };
  },
  methods: {
    buyProduct() {
      if (this.qty != this.$props.quantity) {
        this.loading = true

        api
          .post('store/cart', {
            id: this.$props.id,
            qty: this.qty,
            plus: 'no'
          })
          .then(response => {
            if (response.data.status=='success') {
              this.$noty.success('A quantidade foi atualizada com sucesso.')

              localStorage.removeItem('cart');
              this.$parent.getCart()
            } else {
              this.qty = this.$props.quantity
              this.$noty.error(response.data.message)
            }

            this.loading = false
          })
          .catch(error => {
            if (error) {
              this.$noty.error('Não foi possível adicionar o produto em seu carrinho, tente novamente.')
            }
          })
      }
    },
    editItem(id, qty) {
      if (id) {
        api
          .post('store/cart', {
            id: id,
            qty: qty
          })
          .then(response => {
            if (response.data.status=='success') {
              localStorage.removeItem('cart');
              this.$parent.getCart()
            }
          })
      }
    },
  }
};
</script>

<template>
  <div>
    <template v-if="edit == 'no'">
      <div class="border rounded p-2">{{ qty }}</div>
      <button class="btn btn-link p-0 text-dark font-size-12" v-on:click="editItem(id, 0)">remover</button>
    </template>
    <template v-else>
      <b-form @submit.prevent="buyProduct()" style="width:100px;" class="m-auto">
        <b-form-group class="m-0">
          <b-input-group>
            <b-form-input class="text-center" v-model="qty" type="text" inputmode="numeric" v-mask="'###'" autocomplete="off"></b-form-input>
            <b-input-group-append>
              <b-button v-if="loading" style="width:40px;" class="btn-block font-size-20 py-0 px-2 text-center" type="submit" variant="secondary"><b-spinner small class="align-top mt-2" variant="white" role="status"></b-spinner></b-button>
              <b-button v-else style="width:40px;" class="btn-block font-size-20 py-0 px-2 text-center" type="submit" variant="secondary"><i class="bx bx-analyse align-top mt-1"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
      <button class="btn btn-link p-0 text-dark font-size-12" v-on:click="editItem(id, 0)">remover</button>
    </template>
  </div>
</template>